import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { FileHandle } from 'src/app/shared/directives/file-drop.directive';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-settlement-documents',
  templateUrl: './settlement-documents.component.html',
  styleUrls: ['./settlement-documents.component.scss'],
})
export class SettlementDocumentsComponent implements OnInit, OnDestroy {
  boobleModalData: any;
  formSettlement!: FormGroup;
  showReadMore = true;
  currency: any;
  selectedFiles: FileHandle[] = [];
  fileOver: boolean;
  moedas = Moedas;

  iof: number;
  ir: number;
  commercial: number;

  private readonly notifier: NotifierService;
  public loading: boolean = true;
  private destroy$ = new Subject<void>();

  get settlement(): any {
    return this.formSettlement.value;
  }

  constructor(
    private modalService: BoobleModalService,
    private domSanitizer: DomSanitizer,
    private ordersService: OrdersService,
    notifierService: NotifierService,
    private matIconRegistry: MatIconRegistry,
    private formBuilder: FormBuilder
  ) {
    this.notifier = notifierService;

    this.matIconRegistry.addSvgIcon(
      'cloud-upload',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-upload.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'file',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/image/document-icon.svg'
      )
    );
  }

  ngOnInit() {
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "true")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.boobleModalData = result.data;
            this.initializeComponent();
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          },
        });
    } else {
      this.initializeComponent();
    }
  }

  initializeComponent() {
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData?.currency?.id
    );

    this.formSettlement = this.formBuilder.group({
      exchangeContractFile: [null, Validators.required],
      sendEmail: [true],
    });

    if (this.boobleModalData?.remmitanceType === 'OUTBOUND') {
      this.formSettlement.addControl(
        'swiftFile',
        this.formBuilder.control(null, Validators.required)
      );
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  getModalityText(modalityCode: number) {
    switch (modalityCode) {
      case 1:
        return 'À Vista';
      case 2:
        return 'Antecipado';
      case 3:
        return 'À Prazo';
      default:
        return '-';
    }
  }

  filesDropped(files: FileHandle[]): void {
    this.selectedFiles = files;
  }

  selectFile(event: any) {
    this.selectedFiles.push({
      file: event.target.files[0],
      url: this.domSanitizer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(event.target.files[0])
      ),
    });
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  exchangeContractFileChange(formGroup: FormGroup, event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    formGroup.patchValue({ exchangeContractFile: file });
  }

  swiftFileChange(formGroup: FormGroup, event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    formGroup.patchValue({ swiftFile: file });
  }

  resetControl(controlName: string) {
    this.formSettlement.get(controlName)?.reset();
    this.formSettlement.get(controlName)?.setValue('');
    this.formSettlement.get(controlName)?.markAsPristine();
    this.formSettlement.get(controlName)?.markAsUntouched();
  }

  settlementConfirm() {
    this.loading = true;

    this.ordersService
      .seetlementConfirmExchange(this.boobleModalData?.id, {
        settlement: this.settlement,
        operation: this.selectedFiles,
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.closeModal();
          this.notifier.notify(
            'success',
            'Confirmação de que a ordem foi liquidada realizada com sucesso.'
          );
          this.ordersService.updateOrderView();
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
